const pulse = {
  backgroundColor: 'rgb(202,199,199)',
  animationName: '$pulse',
  animationDuration: '1.5s',
  animationIterationCount: 'infinite',
};

export default pulse;
